import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import Body from "../../components/Body";
import Popup from "../../../../components/Popup/Popup";
import PopupContent from "../../../../components/Popup/PopupContent";
import TextToPay from "../../components/TextToPay";
import ScanToPay from "../../components/ScanToPay";
import CheckInRequest from "../../components/CheckInRequest";
import Settings from "../../components/Settings";
import MemberDetails from "../../components/MemberDetails";
import styles from "./Desktop.module.css";
import FireboardSmsComponent from "../../components/SmsComponent";
import Channels from "../../components/Channels";
import CommonUtil from "../../common";
import CheckActions from "../../components/CheckActions";
// import OverServeReasons from '../../components/OverServeReasons';
import SortFilter from "../../components/SortFilter";
import Moment from 'moment';
import DayPicker from "react-day-picker";
import "react-day-picker/lib/style.css";
import About from "../../components/About";
import ManagerLogin from "../../components/ManagerLogin";
import PreAuth from '../../components/PreAuth';
import NetworkLogs from "../../components/NetworkLogs";
import OutOfStock from "../../components/OutOfStock";
import OutOfStockItems from "../../components/OutOfStock/Items";
import PairWatch from "../../components/PairWatch";
import MarketplaceStatus from "../../components/MarketplaceStatus";
import Diagnostics from "../../../Diagnostics";
import EventEmitter from "../../../../util/event-emitter";
import TableMerge from '../../components/TableMerge';
import RePostPayment from "../../components/RePostPayment";
import ErrorOrder from '../../components/ErrorOrder';
import SensorGroups from "../../components/SensorGroups";
import EditSensorGroup from "../../components/SensorGroups/EditSensorGroup";
import BatchPreauth from "../../components/BatchPreauth";
import { RedeemVoucher, FindVoucher, RedeemSearchedVoucher } from "../../components/RedeemVoucher";
import SensorSelection from "../../components/SensorSelection";
import ProductionRate from "../../components/ProductionRate";
import EditProductionRate from "../../components/ProductionRate/EditProductionRate";
import SwitchMode from "../../components/SwitchMode";
import CubbyLayoutPopup from "../../../StoreCubby/components/CubbyLayoutPopup";
import CubbyMenu from "../../components/CubbyMenu";
import ViewGuestLocation from "../../components/ViewGuestLocation";
import UpdateGuestPhoneNumber from "../../components/UpdateGuestPhoneNumber";
import BulkTextToPay from "../../components/BulkTextToPay/BulkTextToPay";
import ResendReceipt from "../../components/ResendReceipt";
import EmailReceipt from '../../../../components/EmailReceipt';
import SmsReceipt from '../../../../components/SmsReceipt';
import CaptureSeatName from "../../components/CaptureSeatName";
import MultiplePreauth from "../../components/MultiplePreAuth";

export default function Desktop(props) {
  const {
    popup,
    selectedItem,
    isDevEnvironment,
    onHandleSend,
    invokeTextToPay,
    invokeScanToPay,
    invokeCheckIn,
    storeInfo,
    onDateChange,
    onlineOrderAdvanceLimit,
    futureOrdersList,
    items,
    supportsTipsOnTotalAmount,
    showMemberDetailPopup,
    setSelectedCheck,
    onClose: closePopup,
    fromFooter,
    onPressReason,
    submitReason,
    resetSelectedReason,
    reasonsList,
    selectedReason,
    supportNumber,
    buildVersion,
    dismissPopup,
    currency = '$',
    rnDevEnv = false,
    baseUrl,
    iso2,
    onLoginPress,
    networkLogs,
    history,
    rePostPayment,
    isCustomSmsType,
    customSmsList,
    onChangeSmsType,
    viewErrorOrders,
    acknowledgeErrorOrder,
    sensorGroupsList,
    openEditSensorGroupPopup,
    sensorGroup,
    updateSensorGroup,
    closeEditSensorGroupPopup,
    bulkPreAuthChecks,
    defaultPreAuthTipPercentage,
    supportsGratuityForPreAuth,
    updateCheckAfterPreauthTipSubmit,
    deviceName,
    onRedeemVoucher,
    onVoucherSearch,
    searchedVoucher,
    onRedeemSearchedVoucher,
    navigateToSensor,
    productionRateList,
    productionRate,
    productionOverrideReasons,
    openProductionRatePopup,
    onManageOverrides,
    onEditProductionRate,
    currentMode,
    onChangeMode,
    twoDimensionSlot,
    onCubbyMenuPress,
    cubbyLayoutPopupType,
    onMoveSlotOrder,
    onRequestRefreshGuestGPS,
    onOrderDelivered,
    onUpdateGuestInformation,
    deviceGroup,
    bulkTextToPayChecks,
    openResendReceiptPopup,
    receiptHandler,
    emailReceiptHandler,
    smsReceiptHandler,
    receiptTicket,
    onUpdateSeatName,
    openTicketDetails,
  } = props;

  const [keyboardHeight, setKeyboardHeight] = useState(0);

  useEffect(() => {
    var listener;
    if (window.ReactNativeWebView && EventEmitter.getOS() === 'Android') {
      listener = height => setKeyboardHeight(height);
      EventEmitter.addListeners('keyboard', listener);
    }

    return () => {
      listener && EventEmitter.removeListeners('keyboard', listener);
    };
  }, []);

  let orderCounts = {};

  const getDates = () => {
    let dates = []
    futureOrdersList &&
      futureOrdersList.forEach(fc => {
        const businessDate = fc?.businessDate?.split('T')[0];
        const splitDate = businessDate && businessDate.split('-');
        if (splitDate && splitDate.length)
          dates.push(new Date(splitDate[0], (splitDate[1] - 1), splitDate[2]));

        const date = Moment(fc.businessDate).format('YYYY-MM-DD');
        orderCounts[date] = fc?.orderCount || 0;
      });
    return dates;
  }
  const modifiers = {
    futureDates: getDates(),
  };

  const modifiersStyles = {
    futureDates: {
      color: 'white',
      backgroundColor: '#ad0028',
    },
  };

  const isDateFallUnderLimit = pickupDate => {
    const currentDate = Moment(new Date().setHours(0, 0, 0, 0));
    const momentPickupDate = Moment(pickupDate, 'YYYY-MM-DD').local();
    return !currentDate.isSameOrAfter(momentPickupDate) && momentPickupDate.isSameOrBefore(maxDate);
  };

  const minDate = Moment(new Date().setHours(0, 0, 0, 0)).add(1, 'day').toDate();
  const maxDate = Moment(minDate).add(onlineOrderAdvanceLimit - 1, 'days').toDate();

  const getOrderCount = () => {
    const obj = {};
    futureOrdersList &&
      futureOrdersList.forEach(fc => {
        const pickupDate = fc.businessDate?.split('T')[0];
        if (isDateFallUnderLimit(pickupDate)) {
          if (!obj[pickupDate]) obj[pickupDate] = 1;
          else obj[pickupDate] += 1;
        }
      });
    return obj;
  };

  const renderDay = (date, modifiers) => {
    // const allOrdersCount = getOrderCount();
    // const momentPickupDate = Moment(date).format('YYYY-MM-DD');
    // const count = allOrdersCount[momentPickupDate];
    const day = Moment(date).format('DD');
    const fDate = Moment(date).format('YYYY-MM-DD');
    return (
      <div className={styles.day}>
        {modifiers?.futureDates ? <span className={styles.count}>{orderCounts[fDate]}</span> : null}
        {day}
      </div>
    )
  }

  const getPopupContent = () => {
    if (!popup) return;
    switch (popup.type) {
      case "textToPay": {
        return <TextToPay {...popup} invokeTextToPay={invokeTextToPay} selectedItem={selectedItem} fromFooter={fromFooter} onClose={dismissPopup} currency={currency} iso2={iso2} />;
      }
      case "payNow": {
        return <ScanToPay {...popup} invokeScanToPay={invokeScanToPay} onClose={dismissPopup} />;
      }
      case "checkIn": {
        return <CheckInRequest {...popup} invokeCheckIn={invokeCheckIn} selectedItem={selectedItem} fromFooter={fromFooter} onClose={dismissPopup} currency={currency} iso2={iso2} />;
      }
      case "settings": {
        return <Settings {...props} />;
      }
      case "sort": {
        return <SortFilter {...props} />;
      }
      case "channels": {
        return <Channels {...props} />
      }
      case "calendar": {
        getOrderCount();
        return (
          <div className={styles.calendar}>
            {/* <Calendar onChange={onDateChange} value={selectedDate} /> */}
            <DayPicker
              modifiers={modifiers}
              modifiersStyles={modifiersStyles}
              onDayClick={(day, modifiers) => modifiers?.futureDates && onDateChange(day)}
              renderDay={renderDay}
              selectedDays={new Date()}
            />
          </div>
        );
      }
      case "member-details": {
        return <MemberDetails activeItem={popup.metaData} onClose={dismissPopup} iso2={iso2} />
      }
      // case "overServerReasons": {
      //   return <OverServeReasons
      //     reasons={reasonsList}
      //     selectedReason={selectedReason}
      //     onPressReason={onPressReason}
      //     onSubmit={submitReason}
      //     resetSelectedReason={resetSelectedReason}
      //     closePopup={closePopup}
      //   />
      // }
      case "sms": {
        return (
          <FireboardSmsComponent
            selectedItem={selectedItem}
            onHandleSend={onHandleSend}
            storeInfo={storeInfo}
            onClose={dismissPopup}
            iso2={iso2}
            currency={currency}
            isCustomSmsType={isCustomSmsType}
            customSmsList={customSmsList}
            onChangeSmsType={onChangeSmsType}
          />
        );
      }
      case "generate-qr-pay":
      case "generate-qr": {
        return CommonUtil.renderQR(
          popup.meta || null,
          isDevEnvironment,
          dismissPopup,
          items,
          selectedItem,
          supportsTipsOnTotalAmount,
          showMemberDetailPopup,
          currency,
        );
      }
      case "generate-qr-join-check":
        return CommonUtil.renderQRToJoinCheck(
          popup.meta || null,
          popup.sensorData || null,
          isDevEnvironment,
          dismissPopup,
        );
      case "check-options": return (
        <CheckActions
          selectCheck={setSelectedCheck}
          onClose={closePopup}
          {...props}
          currency={currency}
          enableResendReceipt={true}
        />
      );
      case "about": return <About onClose={closePopup} />
      case "managerLogin": {
        return <ManagerLogin
          closePopup={popup?.metaData?.onClose || dismissPopup}
          onLoginPress={onLoginPress}
          indentifier={popup?.metaData?.indentifier || null}
        />;
      }
      case "fbPreAuth":
        return <PreAuth {...props} />;
      case "networkLogs":
        return <NetworkLogs onClose={dismissPopup} networkLogs={networkLogs} />;
      case "outOfStock":
        return <OutOfStock {...props} />;
      case 'items':
      case 'modifiers':
        return <OutOfStockItems {...props} />;
      case 'pairWatch':
        return <PairWatch {...props} />;
      case 'marketplaceStatus':
        return <MarketplaceStatus {...props} />;
      case 'diagnostics':
        return <Diagnostics
          dismissPopup={dismissPopup}
          isComponent={true}
          history={history}
        />;
      case 'tableMerge':
        return <TableMerge {...props} />;
      case 'repostpayment':
        return <RePostPayment
          selectedItem={selectedItem}
          onClose={dismissPopup}
          currency={currency}
          iso2={iso2}
          rePostPayment={rePostPayment} />;
      case 'errorOrder':
        return <ErrorOrder closePopup={dismissPopup} viewErrorOrders={viewErrorOrders} acknowledgeErrorOrder={acknowledgeErrorOrder} />;
      case 'sensorGroups':
        return (
          <SensorGroups
            sensorGroupsList={sensorGroupsList}
            dismissPopup={dismissPopup}
            openEditSensorGroupPopup={openEditSensorGroupPopup}
          />
        );
      case 'editSensorGroup':
        return (
          <EditSensorGroup
            sensorGroup={sensorGroup}
            updateSensorGroup={updateSensorGroup}
            closeEditSensorGroupPopup={closeEditSensorGroupPopup}
          />
        );
      case 'batchPreauth':
        return (
          <BatchPreauth
            currency={currency}
            checks={bulkPreAuthChecks}
            dismissPopup={dismissPopup}
            supportsGratuityForPreAuth={supportsGratuityForPreAuth}
            defaultPreAuthTipPercentage={defaultPreAuthTipPercentage}
            updateCheckAfterPreauthTipSubmit={updateCheckAfterPreauthTipSubmit}
          />
        );
      case 'redeemCheckVoucher':
        return (
          <RedeemVoucher
            iso2={iso2}
            currency={currency}
            selectedCheck={selectedItem}
            onClosePopup={dismissPopup}
            onRedeemVoucher={onRedeemVoucher}
          />
        );
      case 'sensors':
        return (
          <SensorSelection
            navigateToSensor={navigateToSensor}
            dismissPopup={dismissPopup}
          />
        );
      case 'findVoucher':
        return (
          <FindVoucher
            onVoucherSearch={onVoucherSearch}
            dismissPopup={dismissPopup}
          />
        );
      case 'redeemSearchedVoucher':
        return (
          <RedeemSearchedVoucher
            iso2={iso2}
            currency={currency}
            searchedVoucher={searchedVoucher}
            closePopup={dismissPopup}
            redeemVoucher={onRedeemSearchedVoucher}
          />
        );
      case 'productionRateList':
        return (
          <ProductionRate
            onClose={dismissPopup}
            productionRateList={productionRateList}
            onManageOverrides={onManageOverrides}
          />
        );
      case 'editProductionRate':
        return (
          <EditProductionRate
            productionRate={productionRate}
            onClose={openProductionRatePopup}
            onEditProductionRate={onEditProductionRate}
            productionOverrideReasons={productionOverrideReasons}
            actionType={popup?.metaData?.actionType}
          />
        );
      case 'switchMode':
        return (
          <SwitchMode currentMode={currentMode} onChangeMode={onChangeMode} onClose={dismissPopup} />
        );
      case 'cubbyLayout':
        return (
          <CubbyLayoutPopup
            closePopup={dismissPopup}
            twoDimensionSlot={twoDimensionSlot}
            buttonText={cubbyLayoutPopupType}
            onMoveSlotOrder={onMoveSlotOrder}
          />
        );
      case 'cubbyMenu':
        return (
          <CubbyMenu onClose={dismissPopup} onCubbyMenuPress={onCubbyMenuPress} slotName={selectedItem?.slotName} />
        );
      case 'viewOnMap':
        return (
          <ViewGuestLocation
            onClose={dismissPopup}
            check={selectedItem}
            storeInfo={storeInfo}
            currency={currency}
            onRequestRefresh={onRequestRefreshGuestGPS}
            onOrderDelivered={onOrderDelivered}
          />
        );
      case 'updateGuestInformation':
        return (
          <UpdateGuestPhoneNumber
            onClose={dismissPopup}
            iso2={iso2}
            selectedCheck={selectedItem}
            onUpdateGuestInformation={onUpdateGuestInformation}
          />
        );
      case "bulkTextToPay":
        return (
          <BulkTextToPay
            checks={bulkTextToPayChecks}
            dismissPopup={dismissPopup}
            currency={currency}
            iso2={iso2}
            updateCheckAfterPreauthTipSubmit={updateCheckAfterPreauthTipSubmit}
          />
        );
      case 'resendReceipt':
        return (
          <ResendReceipt
            selectedCheck={selectedItem}
            receiptHandler={receiptHandler}
            onClose={dismissPopup}
            currency={currency}
          />
        );
      case 'emailReceipt':
        return (
          <EmailReceipt
            onClose={openResendReceiptPopup}
            onSubmit={emailReceiptHandler}
            defaultEmailAddress={receiptTicket?.receiptEmailAddress || ''}
          />
        );
      case 'smsReceipt':
        return (
          <SmsReceipt
            onClose={openResendReceiptPopup}
            currency={currency}
            onSubmit={smsReceiptHandler}
            defaultPhoneNumber={popup?.metaData?.phoneNumber || ''}
            defaultCountryCode={popup?.metaData?.countryCode || ''}
          />
        );
      case 'captureSeatName':
        return (
          <CaptureSeatName
            onClose={dismissPopup}
            onUpdateSeatName={onUpdateSeatName}
          />
        );
      case 'showMultiplePreauth':
        return (
          <MultiplePreauth
            tickets={popup?.metaData || []}
            onClose={dismissPopup}
            openTicketDetails={openTicketDetails} />
        )
      default: {
        return <PopupContent {...popup} />;
      }
    }
  };

  const getPopupStyle = () => {
    let popupStyle = { width: "31.25vw" };
    if (popup && (popup.type === "settings" || popup.type === "sort")) {
      popupStyle = { width: "56.46vw", height: "90%", overflow: 'scroll' };
    } else if (popup && popup.type === "spinner") {
      popupStyle = { width: "60%" };
    } else if (
      popup &&
      (popup.type === "textToPay" ||
        popup.type === "payNow" ||
        popup.type === "checkIn")
    ) {
      popupStyle = { width: "34vw" };
    } else if (
      popup &&
      (popup.type === "prepTime" || popup.type === "productionRate")
    ) {
      popupStyle = { width: "38vw", padding: "1.78vh" };
    } else if (popup && popup.type === "calendar") {
      popupStyle = { width: 'auto', };
    } else if (popup && popup.type === "sms") {
      popupStyle = { height: "90vh", width: "70vw" };
    } else if (popup && (popup.type === "generate-qr" || popup.type === "generate-qr-pay" || popup.type === "generate-qr-join-check")) {
      popupStyle = { width: "98vw", height: "90vh" };
    } else if (popup && popup.type === "member-details") {
      popupStyle = { width: "34vw" };
    } else if (popup && popup.type === "check-options") {
      popupStyle = { minWidth: '23vw', width: null, maxWidth: '88vw' }
    } else if (popup && popup.type === "channels") {
      popupStyle = { width: "37vw", alignItems: 'center' }
    }
    // else if (popup && popup.type === "overServeReason") {
    //   popupStyle = { width: "27vw", height: "60vh", alignItems: 'center' }
    // }
    else if (popup && popup.type === "about") {
      popupStyle = { width: "34vw" };
    } else if (popup && popup.type === "managerLogin") {
      popupStyle = { width: "100vw", height: "100vh" };
    } else if (popup && popup.type === "fbPreAuth") {
      popupStyle = { width: "100vw", height: "100vh" };
    } else if (popup && popup.type === "networkLogs") {
      popupStyle = { width: "80vw" };
    } else if (popup && (popup.type === "outOfStock" || popup.type === "pairWatch" || popup.type === 'diagnostics' || popup.type === 'marketplaceStatus')) {
      popupStyle = { width: "100vw", height: "100vh" };
    } else if (popup && (popup.type === 'items' || popup.type === 'modifiers')) {
      popupStyle = { width: '90vw', height: '90vh', padding: '1.78vh' };
    } else if (popup && popup.type === "tableMerge") {
      popupStyle = { height: "45vh", width: "45vw", position: 'absolute', top: '7vh' };
    } else if (popup && popup.type === 'repostpayment') {
      popupStyle = { height: '80%', width: '50%' };
    } else if (popup && popup.type === 'errorOrder') {
      popupStyle = { height: '92%', width: '96%', position: 'absolute', bottom: '1vh' };
    } else if (popup && popup.type === 'sensorGroups') {
      popupStyle = { height: '100%', width: '100%' };
    } else if (popup && popup.type === 'editSensorGroup') {
      popupStyle = { height: '50%', width: '40%' };
    } else if (popup && popup.type === 'batchPreauth') {
      popupStyle = { height: '100%', width: '100%' };
    } else if (popup && (popup.type === 'redeemCheckVoucher' || popup.type === 'redeemSearchedVoucher')) {
      popupStyle = { width: '60%' };
    } else if (popup && popup.type === 'sensors') {
      popupStyle = { width: '35%' };
    } else if (popup && popup.type === 'findVoucher') {
      popupStyle = { width: '35%' };
    } else if (popup && popup.type === 'productionRateList') {
      popupStyle = { width: "100vw", height: "100vh" };
    } else if (popup && popup.type === 'editProductionRate') {
      popupStyle = { width: "100vw", height: "100vh" };
    } else if (popup && popup.type === 'switchMode') {
      popupStyle = { width: '30%' };
    } else if (popup && popup.type === 'cubbyLayout') {
      popupStyle = { width: '90%', height: '95%' };
    } else if (popup && popup.type === 'cubbyMenu') {
      popupStyle = { width: '30%' };
    } else if (popup && popup.type === 'viewOnMap') {
      popupStyle = { width: '70%' };
    } else if (popup && popup.type === 'updateGuestInformation') {
      popupStyle = { width: '30%' };
    } else if (popup && (popup.type === 'bulkTextToPay' || popup.type === 'resendReceipt')) {
      popupStyle = { height: '100%', width: '100%' };
    } else if (popup && popup.type === 'captureSeatName') {
      popupStyle = { width: '30%' };
    } else if (popup && popup.type === 'showMultiplePreauth') {
      popupStyle = { height: '80%', width: '70%' };
    }
    return popupStyle;
  };

  return (
    <div className={styles.container} style={{ paddingBottom: keyboardHeight }}>
      <Popup visible={!!popup} popupStyle={getPopupStyle()} closePopup={dismissPopup} >
        {getPopupContent()}
      </Popup>
      <Header {...props} />
      <Body {...props} />
    </div>
  );
}
